/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CallsAliases {
  ACTION_NEW_CALL = 'action-new-call',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_CALLS = 'deck-calls',
  FETCH_0 = 'fetch-0',
  FETCH_CALLS = 'fetch-calls',
  FETCH_LOCATOR = 'fetch-locator',
  FIELD_0 = 'field-0',
  FIELD_01 = 'field-01',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_DT_CLOSE = 'field-dtClose',
  FIELD_DT_OPENNING = 'field-dtOpenning',
  FIELD_LOCATOR = 'field-locator',
  FILTER_CALLS = 'filter-calls',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD_CALLS = 'hpms-custom-card-calls',
  INPUT_0 = 'input-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  PANEL_CALLS = 'panel-calls',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
}
export { CallsAliases };
